import React from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '../../util/reactIntl';

import css from './SectionUsps.module.css';

const USPS = [
  { key: 'usp1', iconClass: css.iconSelection },
  { key: 'usp2', iconClass: css.iconCompare },
  { key: 'usp3', iconClass: css.iconBooking },
  { key: 'usp4', iconClass: css.iconPricing },
];

/**
 * "Vorteile von Toastably" USP grid, ported from the kategorie pages.
 * Chrome-free drop-in section — no outer margins.
 *
 * @param {Object} props
 * @param {string?} props.className
 * @param {string?} props.rootClassName
 */
const SectionUsps = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <section className={classes}>
      <div className={css.container}>
        <div className={css.sectionHead}>
          <h2 className={css.title}>
            <FormattedMessage id="SectionUsps.title" />
          </h2>
        </div>
        <div className={css.uspGrid}>
          {USPS.map(({ key, iconClass }) => (
            <div className={css.usp} key={key}>
              <span className={classNames(css.uspIcon, iconClass)} aria-hidden="true" />
              <h3 className={css.uspTitle}>
                <FormattedMessage id={`SectionUsps.${key}Title`} />
              </h3>
              <p className={css.uspText}>
                <FormattedMessage id={`SectionUsps.${key}Text`} />
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SectionUsps;
